import React, { useEffect, useRef } from 'react';
import { useNavigation } from '@react-navigation/native';

import ScreenWrapper from '../features/Theme/ScreenWrapper';
import AIStrategiesList, { AIStrategiesListHandle } from '../features/AIStrategies/AIStrategiesList';

export default function AIStrategiesListScreen() {
    const navigation = useNavigation<any>();
    const listRef = useRef<AIStrategiesListHandle>(null);

    // Refresh when the screen regains focus — returning from the wizard with a new strategy, or
    // from the detail screen after enable/discard.
    useEffect(() => navigation.addListener('focus', () => listRef.current?.refresh()), [navigation]);

    return (
        <ScreenWrapper>
            <AIStrategiesList
                ref={listRef}
                onOpenStrategy={(strategy) => navigation.navigate('AIStrategyDetails', { strategyId: strategy.id })}
                onCreate={(templateUuid) =>
                    navigation.navigate('CreateAIStrategy', templateUuid ? { templateUuid } : {})
                }
                onClone={(strategyId) => navigation.navigate('CreateAIStrategy', { cloneStrategyId: strategyId })}
            />
        </ScreenWrapper>
    );
}
